import { DOCUMENT } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { SEOService } from '../../services/seo.service';
import { StructuredDataService } from '../../services/structured-data.service';

@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  private document = inject(DOCUMENT);
  private seoService = inject(SEOService);
  private structuredDataService = inject(StructuredDataService);

  ngOnInit() {
    const canonicalUrl = `${environment.canonicalOrigin}/about`;
    this.setSeoMetadata(canonicalUrl);
    this.setStructuredData();
  }

  private setSeoMetadata(canonicalUrl: string) {
    this.seoService.updateTags({
      title: 'About Our AI-Powered News Aggregation | Summerry',
      description:
        'Learn about Summerry, our AI-powered news aggregator that provides concise summaries of the latest artificial intelligence news and developments.',
      keywords: 'About Summerry, AI news platform, news aggregation, artificial intelligence news',
      type: 'website',
      url: canonicalUrl,
      image: `${environment.canonicalOrigin}/assets/og/black-og-image-1x.png`,
    });
  }

  private setStructuredData() {
    const origin = environment.canonicalOrigin;
    const pageUrl = `${origin}/about`;

    this.structuredDataService.addBaseNodes();
    this.structuredDataService.addBreadcrumb([{ name: 'Home', item: origin }, { name: 'About' }]);

    const aboutPageNode = {
      '@type': 'AboutPage',
      '@id': pageUrl,
      url: pageUrl,
      name: 'About Summerry | Summerry',
      description:
        'Learn about Summerry, our AI-powered news aggregator that provides concise summaries of the latest artificial intelligence news and developments.',
      isPartOf: {
        '@id': `${origin}/#website`,
      },
      breadcrumb: {
        '@id': `${pageUrl}#breadcrumb`, // Corrected: Removed trailing slash before #breadcrumb
      },
      mainEntity: {
        '@id': `${origin}/#organization`,
      },
    };

    this.structuredDataService.addNodes(aboutPageNode);
    this.structuredDataService.generateAndInjectSchema();
  }
}
